import { NumberValueAccessor } from '@angular/forms/src/directives';

export class DeviceModel {
    SKUID: number;
    DeviceModel: string;
    DeviceVendor: string;
    Price: string;
    PriceStartDate: string;
    PriceEndDate: string;
    Grade:string;

    //iMac
    ScreenSize: string;
    ProcessorSpeed: string;
    CPU: string;
    VideoCard: string;
    HDD: string;
    SSD: string
    FusionDrive: string;
    RAM: string;
    //iWatch
    DeviceSize: string;
    DeviceConnectionType: string;
    DeviceCasing: string;
    DeviceColor: string;
    DeviceSpecification: string;

    MeasurementUnitType: string;
    DeviceModelFullName: string;
    OperatingSystem: string;
    StorageCapacity: string;
    DeviceModelID: number;
    DeviceManufactureYear: string;
    DeviceType: string;
    DeviceVideoQuality: string;
    DeviceAperture: string;
    Response: string;
    //Macbook
    DeviceDisplayType: string;
    DeviceKeyboardType: string;
}

export enum DeviceCategory {
    MobilePhones = 1,
    iMAC = 2,
    AppleWatch = 3,
    Macbook = 4,
    MicrosoftSurface = 5,
    TabletsAndReader = 6,
    Consoles = 7,
    Camera = 8,
    Lenses = 9
}